import $ from "jquery";

import store from "../store";
import {getCurrentLayout} from "../bvcomponents/appLayout";
import {
  addToCart, removeFromCart,
  setCanvasDimensions,
  setDefaultSelectionGroup,
  setLayoutDataParts,
  updateFabricatorSettings
} from "../actions/actionFunctions";
import ActionTypes from "./actionTypes";
import {AVAILABLE_VISUALIZER_TYPES, getCommonVisualizerType, IS_BATHROOM_OLD_BV_SCENE} from "../config";
import {setVisualizerIsChanging} from "../actions/serverFunctions";
import {
  getCurrentQuoteRoomCartItem,
  getRoomCartItemForCategoryName,
  getRoomNameToCompare
} from "./categorySwitchingFunctions";
import {updateCurrentQuote} from "./quotesFunctions";
import loadVisualizer from "./loadVisualizer";
import {loaderDisable, loaderEnable} from "../bvcomponents/ui/loaderView";
import {
  getCorrectedWizardGroupForFeature,
  getCurrentGroups,
  getDefaultMaterialsWizardItem, getFeatureGroupFromWizardGroup,
  showWizardInsteadOfQT
} from "../bvcomponents/look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {setWizardActiveItem, setWizardIsActive, setWizardSelectedValues} from "../actions/wizardFunctions";
import {setActiveQuoteIndex, setQuotes} from "../actions/roomsFunctions";
import {getCartItemObject} from "./helpers";

export const fixVisualizerType = () => {
  if (document.kvConfig.toolVersion > 4 || IS_BATHROOM_OLD_BV_SCENE || (document.kvConfig.visualizerType === "Fireplace")) {
    document.kvConfig.layersSize = "full_hd";
    switch (document.kvConfig.visualizerType) {
      case "Bathroom":
        document.kvConfig.visualizerType = document.kvConfig.toolVersion === 6 ? "bvLook" : "bvScene";
        break;
      case "Kitchen":
        document.kvConfig.visualizerType = "kvScene";
        break;
      default:
        break;
    }
  } else {
    document.kvConfig.layersSize = "normal";
  }
}

export const hasSubscriptionForRoom = (room) => {
  const {fabricatorState} = store.getState();
  const neededSubscriptionName = getCommonVisualizerType(room);
  return fabricatorState.fabricatorSubscriptions
    && fabricatorState.fabricatorSubscriptions.find(subscription => subscription && subscription.service.toLowerCase() === neededSubscriptionName);
}

/**
 * @param newVisualizerType {string}
 * @param subscription {object} // subscriptionInterface
 * @returns number {number}
 */
export const getToolVersionByVisualizerType = (newVisualizerType, subscription = null) => {
  if (newVisualizerType === AVAILABLE_VISUALIZER_TYPES.Fireplace) {
    return 5
  }
  if (subscription && Number.isInteger(subscription.toolVersion)) {
    return subscription.toolVersion
  }
  switch (newVisualizerType) {
    case AVAILABLE_VISUALIZER_TYPES.Bathroom:
    case AVAILABLE_VISUALIZER_TYPES.Kitchen: {
      return 4
    }
    case AVAILABLE_VISUALIZER_TYPES.bvScene:
    case AVAILABLE_VISUALIZER_TYPES.kvScene: {
      return 5
    }
    case AVAILABLE_VISUALIZER_TYPES.bvLook: {
      return 6
    }
    default:
      return 4
  }
}


/**
 * @param room {string} roomName
 * @param disableLoader {boolean} whether to remove loader or wait on anything else
 */
export const switchToNewVisualizerType = async (room, disableLoader = true) => {
  const {fabricatorState, serverState, quotesState, wizardState} = store.getState();
  if (!fabricatorState.settings.allowVisualizerSwitching) {
    return false
  }
  const {visualizersLoaded} = serverState;

  const existingSubscription = hasSubscriptionForRoom(room);
  if (!existingSubscription) {
    return false
  }
  let oldLayout = getCurrentLayout();
  oldLayout.initialized = false; // stop updating old canvas!
  loaderEnable();

  const newVisualizerType = getVisualizerTypeFromSubscription(existingSubscription);

  store.dispatch(setVisualizerIsChanging(true));

  await updateCurrentQuote(quotesState.activeQuoteIndex, newVisualizerType, false); // create quote with correct room before switching

  console.log("newVisualizerType", newVisualizerType);

  if (!visualizersLoaded.includes(newVisualizerType)) {
    const loaded = await loadVisualizer(newVisualizerType, true);
    if (!loaded) {
      return false
    }
  }
  if (wizardState.wizardIsActiveObject.hasOwnProperty(newVisualizerType)
    && (wizardState.wizardIsActiveObject[newVisualizerType] !== wizardState.wizardIsActive)) {
    store.dispatch(setWizardIsActive(wizardState.wizardIsActiveObject[newVisualizerType]));
  }

  document.kvConfig.visualizerType = newVisualizerType;
  document.kvConfig.toolVersion = getToolVersionByVisualizerType(newVisualizerType, existingSubscription);
  fixVisualizerType(); // set new bathroom or kitchen
  store.dispatch(setCanvasDimensions()); // update canvas height and width (version 4 <> 5 switch)

  const layout = getCurrentLayout();
  if (!layout.initialized) {
    layout.initialized = true; // start updating the canvas in if was stopped earlier
  }
  const layoutParts = layout.getFeatures()
    .filter(parentGroup => parentGroup.categoryEnabled)
    .map((parentGroup) => parentGroup.partName);

  const roomFeatureGroup = layout.getFeatureGroupByPartId("room");
  if (roomFeatureGroup) {
    const newActiveFeature = roomFeatureGroup.features.find(feature => getRoomNameToCompare(feature).toLowerCase() === existingSubscription.service);
    if (newActiveFeature) {
      roomFeatureGroup.activeFeature = newActiveFeature; // set it because it will be set in the materials page after switch

      const {quotesState, wizardState, advancedQuotingState, cartState} = store.getState();
      const {wizardList, wizardIsActive, allWizardsValues, wizardActiveItem} = wizardState;
      const {showAdvancedQuoting} = advancedQuotingState;
      const {cartItems} = cartState;

      if (showWizardInsteadOfQT(wizardList, wizardIsActive)) {
        const nextWizard = getDefaultMaterialsWizardItem();
        if (nextWizard) {
          if (!wizardActiveItem || (wizardActiveItem.id !== nextWizard.id)) {
            store.dispatch(setWizardActiveItem(nextWizard, quotesState.activeQuoteIndex));
          }
          const lastSelectedWizardInThisQuote = allWizardsValues.find(wizObject => {
            return wizObject.quoteIndex === quotesState.activeQuoteIndex && wizObject.isLastActiveWizard
              && nextWizard.id === wizObject.wizardItemId
          });
          if (!lastSelectedWizardInThisQuote || (Object.keys(lastSelectedWizardInThisQuote.wizardSelectedValues).length <= 1)) {
            const wizardActiveStep = 0;
            const currentGroups = getCurrentGroups(nextWizard, wizardActiveStep, {});
            if (currentGroups[0]) {
              const featureGroup = getFeatureGroupFromWizardGroup(currentGroups[0]);
              if (featureGroup && (featureGroup.partId === "room")) {
                store.dispatch(setWizardSelectedValues({
                  [wizardActiveStep]: {
                    wizardGroup: getCorrectedWizardGroupForFeature(currentGroups[0], newActiveFeature),
                    selectedFeature: newActiveFeature,
                    partId: "room",
                  }
                }, quotesState.activeQuoteIndex, nextWizard.id));
                if (showAdvancedQuoting) {
                  const selectedQuoteRoomCartItem = getCurrentQuoteRoomCartItem(cartItems, quotesState.activeQuoteIndex);
                  if (selectedQuoteRoomCartItem) {
                    store.dispatch(removeFromCart(selectedQuoteRoomCartItem));
                  }
                  const roomCartItem = getCartItemObject(newActiveFeature, 1, "");
                  roomCartItem.currentQuote = quotesState.activeQuoteIndex;
                  roomCartItem.fromWizardId = nextWizard.id;
                  roomCartItem.fromWizardStep = wizardActiveStep;
                  roomCartItem.fromWizardGroupId = currentGroups[0].id;
                  store.dispatch(addToCart([roomCartItem]));
                }
              }
            }
          }
        }
      }
    }
  }

  store.dispatch(setLayoutDataParts(layoutParts));
  store.dispatch(setDefaultSelectionGroup(layoutParts[0]));
  store.dispatch(updateFabricatorSettings());

  $(window).trigger(ActionTypes.UPDATE_ALL_ITEMS);

  console.log("finish visualizer change", document.kvConfig.visualizerType);

  setTimeout(() => {
    store.dispatch(setVisualizerIsChanging(false));
  }, 300) // prevent materials page canvas jumping

  if (disableLoader) {
    loaderDisable();
  } // else we wait in server reducer, when it is added to loaded
  return true
}

export const getVisualizerTypeFromSubscription = (subscription) => {
  const toolVersionToCheck = subscription.toolVersion || 4;
  switch (subscription.service) {
    case "Bathroom":
    case "bathroom":
      return toolVersionToCheck === 6
        ? "bvLook"
        : toolVersionToCheck === 5 ? "bvScene" : "Bathroom"
    case "Kitchen":
    case "kitchen":
      return toolVersionToCheck === 5 ? "kvScene" : "Kitchen"
    case "Fireplace":
    case "fireplace":
      return "Fireplace"
    default:
      return subscription.service
  }
}

/**
 * @param quoteIndex {number}
 * @param nextVisualizerType {string}
 * @returns {string}
 */
export const getQuoteVisualizerType = (quoteIndex, nextVisualizerType) => {
  const {quotesState, cartState, fabricatorState, serverState} = store.getState();
  const {cartItems} = cartState;
  const {quotes, activeQuoteIndex} = quotesState;

  if (fabricatorState.settings.allowVisualizerSwitching) {
    const roomCartItem = getCurrentQuoteRoomCartItem(cartItems, quoteIndex);
    if (roomCartItem) {
      const existingSubscription = hasSubscriptionForRoom(getRoomNameToCompare(roomCartItem.cartFeature));
      if (existingSubscription) {
        return getVisualizerTypeFromSubscription(existingSubscription);
      }
    }
    const quoteCartItems = cartItems.filter(cartItem => {
      return (cartItem.currentQuote === quoteIndex) && !(cartItem.cartFeature && cartItem.cartFeature.dbFeature.autoAddToCart)
        && !(cartItem.cartFeature
          && cartItem.cartFeature.dbFeature.displayLogic
          && Array.isArray(cartItem.cartFeature.dbFeature.displayRules)
          && cartItem.cartFeature.dbFeature.displayRules.some(rule => rule))
    });
    if (quoteCartItems.length && quoteCartItems[0].fromVisualizerType
      && quoteCartItems.every(cartItem => cartItem.fromVisualizerType === quoteCartItems[0].fromVisualizerType)) {
      return quoteCartItems[0].fromVisualizerType
    }
    if (nextVisualizerType) { // if we don't have any cart items or room cart item and we are switching visualizer -> set it's type
      return nextVisualizerType
    }
    if (quoteIndex === activeQuoteIndex && !serverState.visualizerIsChanging) {
      return document.kvConfig.visualizerType
    }
  }
  if (quotes && quotes[quoteIndex] && quotes[quoteIndex].room) {
    return quotes[quoteIndex].room
  }
  return document.kvConfig.visualizerType
}


/**
 * @param featureClicked {featureInterface}
 * @param roomName {string}
 * @param fabricatorSettings {object}
 * @param visualizerIsChanging {boolean}
 * @returns {string|boolean}
 */
export const shouldSwitchVisualizer = (featureClicked, roomName, fabricatorSettings, visualizerIsChanging) => {
  if (!fabricatorSettings.allowVisualizerSwitching || visualizerIsChanging) {
    return false
  }

  let room = roomName || getRoomNameToCompare(featureClicked);

  // 2) if user clicked on unavailable visualizer -> go and set initial visualizer!
  const hasSubscription = hasSubscriptionForRoom(room);

  // 3) set main config visualizer type
  const newVisualizerType = hasSubscription ? getVisualizerTypeFromSubscription(hasSubscription) : null;
  if (newVisualizerType && (document.kvConfig.visualizerType !== newVisualizerType)) {
    return newVisualizerType
  }
  return false
}


/**
 * not used for now! but let it be
 * @param newRoomName {string}
 * @param needToAddRoomToCart {boolean}
 * @returns {Promise}
 */
export const createNewQuoteAfterVisualizerChange = async (newRoomName = "", needToAddRoomToCart = true) => {
  const {fabricatorState, quotesState} = store.getState();
  const {quotes, activeQuoteIndex} = quotesState;

  const currentQuote = await updateCurrentQuote(activeQuoteIndex);
  const newQuotes = [...currentQuote, {}];
  const newActiveQuoteIndex = quotes.length; // for example, if length is 2 (we are adding 2 index(0 and 1 already exist))
  store.dispatch(setQuotes(newQuotes));
  store.dispatch(setActiveQuoteIndex(newActiveQuoteIndex));
  if (needToAddRoomToCart) {
    const roomCartItem = getRoomCartItemForCategoryName(newRoomName, fabricatorState.settings);
    if (roomCartItem) {
      const newRoomCartItem = Object.assign({}, roomCartItem, {
        currentQuote: newActiveQuoteIndex
      })
      store.dispatch(addToCart([newRoomCartItem]));
    }
  }
  return Promise.resolve(true)
}
